import { app } from '../shared';

export const fetchCountries = async (findBody = {}) => {
  return app.service('countries').find(findBody);
};
